import React from 'react'
import { useState } from 'react'
import { Button, Image } from 'react-bootstrap'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'
import { fnDateEn } from '../../../helper/fnDateEn'
import { getProvidentFundAPI } from '../../../services/provident-fund'
import SwalCustom from '../../../alert/swal-custom'
import { saveAs } from 'file-saver'
import excelImg from '../../../images/xlsFile.svg'
import { createSpreadsheetBlob } from '../../../helper/spreadsheet/write-spreadsheet'
import { buildProvidentFundReportSheet } from '../../../helper/spreadsheet/provident-fund-report'

export default function ExportExcelPVD({ bodyFilter, totalRows }) {
  const [IsExcel, setIsExcel] = useState(false)
  const handleExport = async () => {
    setIsExcel(true)
    // getProvidentFundExcel()
    const body = {
      ...bodyFilter,
      page: 1,
      size: totalRows
    }
    try {
      await getProvidentFund(body)
    } finally {
      setIsExcel(false)
    }
  }
  const getProvidentFund = async (body) => {
    try {
      const result = await getProvidentFundAPI(body)
      if (!result) return
      if (result.status) {
        await getProvidentFundExcel(result.result)
      } else {
        Error_false(result)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const getProvidentFundExcel = async (data) => {
    const dataExcel = data.map((d, i) => {
      return {
        num: i + 1,
        code: d?.code,
        name_en: d?.title_th + ' ' + d?.name_th + ' ' + d?.surname_th,
        start_date: d?.start_date
          ? fnDateEn(d?.start_date).format('DD/MM/YYYY')
          : '-',
        plan_name: d?.plan_name ?? '-',
        percent: d?.percent,
        end_date: d?.end_date
          ? fnDateEn(d?.end_date).format('DD/MM/YYYY')
          : '-',
        type_name: d?.type_name,
        status_name: d?.status_name
      }
    })
    await exportExcel(dataExcel, 'Provident-Fund')
  }
  const exportExcel = async (dataExcel, name) => {
    const { sheetData, sheetOptions } = buildProvidentFundReportSheet({
      data: dataExcel
    })
    const blob = await createSpreadsheetBlob(sheetData, sheetOptions)

    saveAs(blob, `${name}.xlsx`)
    SwalCustom({
      title: 'Success!',
      text: 'Exported',
      icon: 'success',
      showConfirmButton: false,
      timer: 1500
    })
  }

  return (
    <Button disabled={IsExcel} onClick={handleExport} size="sm">
      <Image src={excelImg} style={{ width: '15px' }} />
    </Button>
  )
}
